// extracted by mini-css-extract-plugin
export default {"header":"FbTe02jbcXXvYBvrJ5f2","content":"Uh47AXopSAQcOa8BImuh","button":"rXWvpVadYScTpiO6qDZi","placeHolderShimmer":"UH8y8Bob2m1mA7lPgNQU"};